import Lottie from "lottie-react";
import animationData from "./folder-import-timeout.json";

interface LottieAnimationProps {
  height?: number;
  width?: number;
  loop?: boolean;
}

export function TimeoutLottieAnimation({
  height = 300,
  width = 300,
  loop = true,
}: LottieAnimationProps) {
  return (
    <div style={{ height, width }}>
      <Lottie animationData={animationData} loop={loop} />
    </div>
  );
}
